import { union } from "superstruct";

import InstagramPostImageMediaSchema from "./InstagramPostImageMediaSchema";
import InstagramPostVideoMediaSchema from "./InstagramPostVideoMediaSchema";

const InstagramPostMediaSchema = union([
    InstagramPostImageMediaSchema,
    InstagramPostVideoMediaSchema,
]);

export default InstagramPostMediaSchema;
